import React, {FC, PropsWithChildren, useEffect} from 'react';

import {cn} from '@bem-react/classname';
import {Loader} from '@gravity-ui/uikit';
import useCSRFSync from 'ui/hooks/useCSRFSync';
import * as Metrika from 'ui/utils/metrika';

import Footer from '../Footer';
import Header from '../Header';
import IframeLayout from '../IframeLayout';
import PreviewLayout from '../PreviewLayout';

import './Layout.scss';

const {iframe, preview} = window.YC;
const cnLayout = cn('Layout');

const Layout: FC<PropsWithChildren<{}>> = ({children}) => {
    const synced = useCSRFSync();

    const content = synced ? children : <Loader size="l" className={cnLayout('Loader')} />;

    useEffect(() => {
        Metrika.common();
    }, []);

    if (iframe) {
        return <IframeLayout>{content}</IframeLayout>;
    }
    if (preview) {
        return <PreviewLayout>{content}</PreviewLayout>;
    }
    return (
        <div className={cnLayout()}>
            <Header />
            <main className={cnLayout('Content')}>{content}</main>
            <Footer />
        </div>
    );
};
export default Layout;
